export default "__VITE_ASSET__HmRyf3Kh__"